var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "main", staticClass: "main" }, [
    _c(
      "span",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isShowArrow,
            expression: "isShowArrow"
          }
        ],
        staticClass: "span-arrow-left",
        class: { "no-allowed": !_vm.isAllowedLeft },
        on: {
          click: function($event) {
            _vm.isAllowedLeft && _vm.leftArrowBtn()
          }
        }
      },
      [_c("i", { staticClass: "el-icon-arrow-left" })]
    ),
    _vm._v(" "),
    _vm.isShowArea
      ? _c(
          "div",
          {
            staticClass: "show_area",
            style: { width: _vm.show_area_width + "px" }
          },
          [
            _c(
              "div",
              {
                ref: "area",
                staticClass: "area",
                style: { left: _vm.leftLength + "px" }
              },
              _vm._l(_vm.datas, function(tag, index) {
                return _c(
                  "el-tag",
                  {
                    key: index,
                    attrs: { title: tag.name, closable: _vm.isClosable },
                    on: {
                      close: function($event) {
                        return _vm.handleClose(tag)
                      }
                    }
                  },
                  [_vm._v(_vm._s(tag.name))]
                )
              }),
              1
            )
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "span",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isShowArrow,
            expression: "isShowArrow"
          }
        ],
        staticClass: "span-arrow-right",
        class: { "no-allowed": !_vm.isAllowedRight },
        on: {
          click: function($event) {
            _vm.isAllowedRight && _vm.rightArrowBtn()
          }
        }
      },
      [_c("i", { staticClass: "el-icon-arrow-right" })]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5167b41e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5167b41e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/course/components/v_labels.vue
// module id = null
// module chunks = 